"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webix_jet_1 = require("webix-jet");
const globals_1 = require("models/globals");
class Entreprise extends webix_jet_1.JetView {
    config() {
        return {
            view: "window",
            height: 800,
            width: 650,
            modal: true,
            position: "center",
            head: (0, globals_1._)("Informations de l'entreprise"),
            body: {
                view: "form", id: "entreprise.data",
                elementsConfig: { maxWidth: 500, labelAlign: "right", labelWidth: 120 },
                elements: [{
                        view: "text", name: "unid", label: (0, globals_1._)("N°"),
                        width: "400", attributes: { maxlength: 40 },
                        editor: "text", hidden: true
                    }, {
                        view: "text", name: "nom", label: (0, globals_1._)("Nom usuel"),
                        width: "400", attributes: { maxlength: 40 },
                        editor: "text"
                    }, {
                        view: "text", name: "raisonSociale", label: (0, globals_1._)("Raison sociale"),
                        width: "400", attributes: { maxlength: 40 },
                        editor: "text", readonly: true
                    }, {
                        view: "text", name: "adresseSuite", label: (0, globals_1._)("Adresse"),
                        width: "400", attributes: { maxlength: 40 }, editor: "text"
                    }, {
                        view: "text", name: "adresseRue", label: (0, globals_1._)("N° et rue"),
                        width: "400", attributes: { maxlength: 40 },
                        editor: "text"
                    }, {
                        cols: [{
                                view: "text", name: "adresseCP", label: (0, globals_1._)("Code Postal"),
                                width: "200", attributes: { maxlength: 5 }, editor: "text"
                            }, {
                                view: "text", name: "adresseVille", label: (0, globals_1._)("Ville"),
                                width: "400", labelWidth: 60, attributes: { maxlength: 34 }, editor: "text"
                            }]
                    }, {
                        view: "text", name: "pays", label: (0, globals_1._)("Pays"),
                        width: "300", attributes: { maxlength: 24 }, editor: "text"
                    }, {
                        view: "text", name: "email", label: (0, globals_1._)("E-mail"), width: "400",
                        attributes: { maxlength: 40 }, editor: "text",
                        invalidMessage: "L'adresse e-mail n'est pas valide"
                    }, {
                        cols: [{
                                view: "text", name: "siret", label: (0, globals_1._)("N° Siret"), width: "300",
                                attributes: { maxlength: 17 }, editor: "text", readonly: true
                            }, {
                                view: "text", name: "numTVA", label: (0, globals_1._)("Numéro TVA"), width: "300",
                                attributes: { maxlength: 15 }, editor: "text"
                            }, { height: 1 }]
                    }, {
                        cols: [{
                                view: "text", name: "telephone", label: (0, globals_1._)("Téléphone"),
                                width: "300", attributes: { maxlength: 24 }, editor: "text"
                            }, {
                                view: "text", name: "mobile", label: (0, globals_1._)("Mobile"),
                                width: "300", attributes: { maxlength: 24 }, editor: "text"
                            }]
                    }, {
                        cols: [{
                                view: "datepicker", name: "debutExercice", localId: "debutExercice", label: (0, globals_1._)("Début exercice"),
                                width: "250", attributes: { maxlength: 12 }, stringResult: true
                            }, {
                                view: "datepicker", name: "finExercice", localId: "finExercice", label: (0, globals_1._)("Fin exercice"),
                                width: "250", attributes: { maxlength: 12 }, stringResult: true
                            }]
                        // }, {
                        // 	cols : [{
                        // 		view : "select", name : "moisFacturation", localId : "moisFacturation", label : _("Mois de facturation"),
                        // 		width : "280", attributes : {maxlength : 12}, labelWidth : 150
                        // 		, options : ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"]
                        // 	}]
                    }, { cols: [
                            { view: "button", label: (0, globals_1._)("Annuler"), id: "entrepriseAnnulerButton",
                                click: () => this.annuler()
                            }, {
                                view: "button", label: (0, globals_1._)("Enregistrer"), id: "entrepriseEnregistrerButton", hidden: true,
                                click: () => this.enregistrer()
                            }
                        ]
                    }, {
                        template: "", fillspace: true, height: 1
                    }],
                rules: {
                    "email": webix.rules.isEmail
                }
            }
        };
    }
    annuler() {
        // @ts-ignore
        this.getRoot().close();
    }
    enregistrer() {
        if (this.currentForm.validate()) {
            let me = this;
            let values = this.currentForm.getValues();
            let vv = JSON.stringify(values);
            let xx = { "cle": "organisation.data", "texte": vv };
            // @ts-ignore
            let promise = webix.ajax().post(globals_1.phpPath + "parametres.php?option=savejson", xx);
            promise.then(function (result) {
                if (result.json().success == false) {
                    webix.alert(result.json().message);
                    return;
                }
                webix.message("Données enregistrées");
                const w = me.getRoot();
                w.close();
            });
            promise.catch(function () {
                webix.alert((0, globals_1._)("Erreur d'enregistrement des données entreprise"));
                const w = me.getRoot();
                w.close();
            });
        }
    }
    showWindow() {
        const w = this.getRoot();
        w.show();
    }
    init() {
        this.moduleName = "entreprise";
        let me = this;
        this.currentForm = $$("entreprise.data");
        this.currentForm.load(globals_1.phpPath + "parametres.php?key=organisation.data&option=readjson");
        if ((globals_1.lv2.droits).includes("parametres.savejson.entreprise"))
            $$("entrepriseEnregistrerButton").show();
        this.currentForm.attachEvent("onAfterLoad", function () {
            // @ts-ignore
            let vv = this.getValues();
            if (!vv["debutExercice"]) {
                let xx = (new Date()).getFullYear();
                let debutExercice = me.$$("debutExercice");
                debutExercice.setValue(String(new Date(xx, 0, 1)));
            }
            if (!vv["finExercice"]) {
                let xx = (new Date()).getFullYear();
                let finExercice = me.$$("finExercice");
                finExercice.setValue(String(new Date(xx, 11, 31)));
            }
        });
    }
}
exports.default = Entreprise;
